import React from 'react';
import { PageMetaTags as PageMeta, PageMetaTagsProps } from '@cp/shared/metaTags';
import { useHelmet } from 'src/shared/helmet';
import { MetaTagRenderConfig } from '../../../../hooks/useMetaTags';

export interface MetaTagsProps extends Omit<PageMetaTagsProps, 'HeadComponent'> {
  renderConfig?: MetaTagRenderConfig[];
}

export const PageMetaTags = ({ renderConfig, ...props }: MetaTagsProps) => {
  const Helmet = useHelmet();
  return <PageMeta HeadComponent={Helmet} tagsConfig={renderConfig} {...props} />;
};
